import { Component, OnInit, Output, ViewChild, EventEmitter, Input, OnChanges, SimpleChanges, effect } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';
import { MenuItem } from 'primeng/api';
import { TabMenu, TabMenuModule } from 'primeng/tabmenu';
import { Event } from 'src/app/common/events/event-base';
import { InMemoryCacheService } from 'src/app/common/cache/in-memory-cache.service';
import { MessageType } from 'src/app/common';
import { UtilsService } from 'src/app/common/services/utils.service';
import { KeywordSearchOptions } from 'src/app/pages/seo/models/keyword-search-options';
import { AvailableLanguage, SeoLanguage } from 'src/app/common/models/dataforseo/language';
import { RuleSet } from 'ngx-angular-query-builder';
import { SEOQueryBuilder } from 'src/app/pages/seo/models/query-builder';
import { QueryBuilderProcessor } from 'src/app/pages/seo/models/query-builder-processor';
import { DropdownChangeEvent, DropdownModule } from 'primeng/dropdown';
import { KeywordSearchService } from '../../keyword-search/keyword-search.service';
import { InputTextModule } from 'primeng/inputtext';
import { ButtonModule } from 'primeng/button';
import { TranslateModule } from '@ngx-translate/core';
import { AdvanceFilterComponent } from '../advance-filter/advance-filter.component';
import { SelectButtonModule } from 'primeng/selectbutton';

@Component({
  selector: 'gig-keyword-input',
  standalone: true,
  imports: [CommonModule, FormsModule, TabMenuModule, DropdownModule, InputTextModule, ButtonModule, TranslateModule, AdvanceFilterComponent, SelectButtonModule],
  templateUrl: './keyword-input.component.html',
  styleUrls: ['./keyword-input.component.scss']
})
export class KeywordInputComponent implements OnInit, OnChanges {

  public items: MenuItem[];
  public activeItem: MenuItem;
  public selectedLocation: SeoLanguage;
  public selectedLanguage: AvailableLanguage;
  public keyword: string;
  public domain: string;
  public advanceFilterMessage: string;
  public searchMenuOptions: any;
  public selectedSearchMenuOption: any;
  public locationOptions: SeoLanguage[];
  public languageOptions: AvailableLanguage[];

  @ViewChild('tabMenu') tabMenu: TabMenu;

  @Output() searchClicked: EventEmitter<any> = new EventEmitter<any>();
  @Output() tabChanged: EventEmitter<any> = new EventEmitter<any>();
  @Output() searchTypeChanged: EventEmitter<string> = new EventEmitter<string>();

  @Input() qbConfig: SEOQueryBuilder;
  @Input() ruleset: RuleSet;
  @Input() qbProcessor: QueryBuilderProcessor;
  @Input() source: string = '';
  @Input() isNeed: boolean = false;
  @Input() isNotAdvanceSearch: boolean = false;
  @Input() locationCode: number;

  @Input() enableSearch: boolean = true;

  constructor(private utils: UtilsService, public cache: InMemoryCacheService, private keywordSearchService: KeywordSearchService) {
    effect(() => {
      this.utils.logger.info('KeywordInputComponent.loadMore() -- effect 1');
      if (this.keywordSearchService.loadMore() || !this.keywordSearchService.loadMore()) {
        this.utils.logger.info('KeywordInputComponent.loadMore() -- effect 2');
        this.search(true);
      }
    });
  }

  ngOnInit(): void {
    this.items = [
      { label: 'Search by Keyword' },
      {label: 'Search by Domain'},

    ];

    this.activeItem = this.items[0];

    // if (this.source == 'amazon') {
    //   this.locationOptions = this.cache.amazonLocations;
    //   this.selectedLocation = this.locationOptions.find((location) => location.locationCode === 2840);
    //   this.languageOptions = this.cache.amazonLanguages;
    //   this.selectedLanguage = this.cache.amazonLanguages.find((language) => language.languageCode === 'en_US');
    // } else {

    this.locationOptions = this.cache.seoLanguages.filter(({ availableLanguages }) => availableLanguages?.[0]?.availableSources?.includes(this.source));
    this.selectedLocation = this.locationOptions.find((location) => location.locationCode === 2840);
    this.languageOptions = this.selectedLocation.availableLanguages;
    this.selectedLanguage = this.selectedLocation.availableLanguages.find((language) => language.languageCode === 'en');
    // }


    this.searchMenuOptions = [
      { name: "Keyword Ideas", value: "keywordIdeas" },
      { name: "Auto Complete", value: "keywordSuggestions" },
      { name: "Related Keywords", value: "relatedKeywords" }
    ];

    this.selectedSearchMenuOption = this.searchMenuOptions[0];
  }

  ngOnChanges(changes: SimpleChanges): void {
    if (changes.locationCode && changes.locationCode.currentValue) {
      this.selectedLocation = this.locationOptions.find(location => location.locationCode === changes.locationCode.currentValue);
      if (this.selectedLocation) {
        this.languageOptions = this.selectedLocation.availableLanguages;
        this.selectedLanguage = this.languageOptions[0];
      }
    }
  }

  public onTabMenClicked(): void {
    this.utils.logger.info('KeywordInputComponent.onTabMenClicked()');
    this.activeItem = this.tabMenu.activeItem;
    this.tabChanged.emit(new TabChangedEvent('TabChangedEvent.TAB_CHANGED', this.activeItem));
  }

  public onLocationChange(e: DropdownChangeEvent) {
    this.utils.logger.info(`KeywordSearchService.onLocationChange() `);
    this.languageOptions = this.selectedLocation.availableLanguages;
    this.selectedLanguage = this.languageOptions[0];
  }

  public onSearchClicked(e: any): boolean {
    e.preventDefault();
    this.utils.logger.info('KeywordInputComponent.onSearchClicked() ');

    this.search(false);

    return true;
  }
  public setSearchOptions(data: any, source: string) {
    switch (source) {
      case 'google':
        return data;
      case 'bing':
        return 'relatedKeywords';
      case 'amazon':
        return 'relatedKeywords';
      default:
        return data;
    }
  }
  public onAdvanceFilterChange(e: any): void {
    this.utils.logger.info('KeywordInputComponent.onAdvanceFilterChange() ');
    this.ruleset = e.payload
  }

  public onSearchMenuOptionClicked(e: any): boolean {
    this.utils.logger.info('KeywordInputComponent.onSearchClicked() ', JSON.stringify(e));
    this.searchTypeChanged.emit(e.option.value);

    const options: KeywordSearchOptions = {
      keyword: this.keyword,
      languageCode: this.selectedLanguage.languageCode,
      locationCode: this.selectedLocation.locationCode,
      query: this.ruleset,
      searchMenuOption: e.option.value,
      menuOptionClicked: true
    };

    if (!this.keyword) return false;
    this.utils.logger.info('KeywordInputComponent.onSearchClicked() - KeywordInput.KEYWORD_SEARCH_CLICKED');
    this.searchClicked.emit(new KeywordInputEvent('KeywordInput.KEYWORD_SEARCH_CLICKED', options));
    return true;
  }

  public clearSearch(): void {
    if (this.activeItem.label === 'Search by Domain') {
      this.domain = '';
    } else {
      this.keyword = '';
    }
  }

  private search(loadMore: boolean = false): boolean {
    this.utils.logger.info('KeywordInputComponent.search() ');
    const options: KeywordSearchOptions = {
      keyword: this.activeItem.label === 'Search by Domain' ? this.domain : this.keyword,
      languageCode: this.selectedLanguage.languageCode,
      locationCode: this.selectedLocation.locationCode,
      query: this.ruleset,
      searchMenuOption: this.setSearchOptions(this.selectedSearchMenuOption.value, this.source),
      menuOptionClicked: false,
      loadMore: loadMore
    };

    this.utils.logger.info('KeywordInputComponent.onSearchClicked() query string');

    if (this.activeItem.label === 'Search by Domain') {
      this.utils.logger.info('KeywordInputComponent.onSearchClicked() - KeywordInput.DOMAIN_SEARCH_CLICKED');
      if (!this.domain) return false;
      this.domain = this.normalizeDomain(this.domain);
      if (!this.isValidDomain(this.domain)) {
        this.utils.errorMessage(MessageType.TOAST, 'Please enter a valid domain name');
        return false;
      }
      options.keyword = this.domain;
      this.searchClicked.emit(new KeywordInputEvent('KeywordInput.DOMAIN_SEARCH_CLICKED', options));
    } else {
      this.utils.logger.info('KeywordInputComponent.onSearchClicked() - KeywordInput.KEYWORD_SEARCH_CLICKED');
      if (!this.keyword) return false;
      this.searchClicked.emit(new KeywordInputEvent('KeywordInput.KEYWORD_SEARCH_CLICKED', options));
    }

    return true;
  }

  private normalizeDomain(value: string): string {
    let v = (value || '').trim();
    v = v.replace(/^https?:\/\//i, '');
    v = v.split('/')[0].split('?')[0].split('#')[0];
    return v;
  }

  private isValidDomain(value: string): boolean {
    return /^([a-zA-Z0-9]([a-zA-Z0-9\-]{0,61}[a-zA-Z0-9])?\.)+[a-zA-Z]{2,}$/.test(value);
  }

}

export class KeywordInputEvent extends Event {
  constructor(type: string, payload: any) {
    super(type, payload);
  }
}

export class TabChangedEvent extends Event {
  constructor(type: string, payload: any) {
    super(type, payload);
  }
}
